<template>
  <div class="notification-module-modal">
    <div class="notification-module-modal-sidebar">
      <span class="notification-module-modal-sidebar-label">Ações</span>
      <button
        v-for="action in module.actions"
        :key="action.actionKey"
        type="button"
        class="notification-module-modal-sidebar-btn"
        :class="{ 'is-active': selectedActionKey === action.actionKey }"
        @click="selectedActionKey = action.actionKey"
      >
        <span class="notification-module-modal-badge" :class="getBadgeClass(action.actionKey)">
          <i :class="action.actionIcon"></i>
          {{ action.actionLabel }}
        </span>
        <span class="notification-module-modal-sidebar-desc">{{ action.description }}</span>
      </button>
    </div>

    <div class="notification-module-modal-panel">
      <NotificationActionPanel
        v-if="selectedAction"
        :key="selectedActionKey"
        :action="selectedAction"
        :channelTypes="channelTypes"
        :groupsAvailable="groupsAvailable"
        @open-params="$emit('open-params', module.parametersKey)"
        @save="$emit('save')"
      />
    </div>
  </div>
</template>

<script>
import NotificationActionPanel from "./NotificationActionPanel.vue";

export default {
  name: "NotificationModuleModal",
  components: { NotificationActionPanel },
  props: {
    module: {
      type: Object,
      required: true,
    },
    channelTypes: {
      type: Array,
      required: true,
    },
    groupsAvailable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedActionKey: null,
    };
  },
  watch: {
    "module.key": {
      immediate: true,
      handler() {
        this.selectedActionKey = this.module?.actions?.[0]?.actionKey || null;
      },
    },
  },
  computed: {
    selectedAction() {
      if (!this.selectedActionKey) return null;
      return this.module.actions.find((a) => a.actionKey === this.selectedActionKey) || null;
    },
  },
  methods: {
    getBadgeClass(actionKey) {
      const key = (actionKey || "").toLowerCase();
      if (key.includes("aprovar")) return "badge-success";
      if (key.includes("reprovar") || key.includes("recusar") || key.includes("negar")) return "badge-danger";
      if (key.includes("saida")) return "badge-saida";
      if (key.includes("retorno")) return "badge-retorno";
      if (key.includes("tarefa")) return "badge-warning";
      return "badge-default";
    },
  },
};
</script>

<style scoped>
.notification-module-modal {
  display: flex;
  height: 560px;
  overflow: hidden;
}

.notification-module-modal-sidebar {
  width: 200px;
  flex-shrink: 0;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  background: var(--bg-elevated);
}

.notification-module-modal-sidebar-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0 4px 8px;
}

.notification-module-modal-sidebar-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 10px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: 0.15s ease;
  width: 100%;
}

.notification-module-modal-sidebar-btn:hover {
  background: var(--bg-hover);
}

.notification-module-modal-sidebar-btn.is-active {
  background: var(--bg-base);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.notification-module-modal-sidebar-desc {
  font-size: 11px;
  color: var(--text-muted);
  line-height: 1.4;
}

.notification-module-modal-panel {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  background: var(--bg-base);
}

.notification-module-modal-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  color: var(--text-inverse);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.badge-default  { background: #577696; }
.badge-success  { background: #16a34a; }
.badge-danger   { background: #dc2626; }
.badge-saida    { background: #019183; }
.badge-retorno  { background: #3D4EAE; }
.badge-warning  { background: #d97706; }
</style>
